
define('text!modules/T1App/edit/access/users/templates/userBin.html',[],function () { return '<div class="bin-header"><strand-icon class="icon" type="include" width="16" height="16"></strand-icon> Applied User Permissions</div>\n<div class="dev-team-container"></div>';});

